<template>
	<div style="background: #eff2fa !important;">
		<div style="background-color: #fff;"><Myheaderesa></Myheaderesa></div>
		
		<div class="headerscourdetail">
			<img src="@/images/images/ykc/u12.png" alt="" />
			<div class="headerfonts">
				<p>{{ tabcourseobj.CO_CoursesName }}</p>
				<p>{{ tabcourseobj.pro_name ?? '' }}</p>
			</div>
		</div>

		<div class="detailscontengt">
			<div class="flex">
				<div style="height: 400px;width: 600px;margin-right: 60px;">
					<img
						style="height: 400px;width: 600px;margin-right: 60px;"
						:src="tabcourseobj.CO_CoverImgUrl ? tabcourseobj.CO_CoverImgUrl : 'https://www.hngtsd.net:65535/appstatic/images/ykc1.png'"
						alt=""
					/>
				</div>
				<div>
					<p class="detailscontitle">课程介绍</p>
					<div :title="tabcourseobj.CO_Introduced" class="detacontent">{{ tabcourseobj.CO_Introduced }}</div>
					<p>
						专业：
						<span>{{ tabcourseobj.pro_name ?? '' }}</span>
					</p>
					<p>
						岗位：
						<span>{{ tabcourseobj.PR_ProfessionalName }}</span>
					</p>
					<p>
						课程学时：
						<span>{{ tabcourseobj.CO_Learning }}</span>
					</p>
					<p>
						学习进度：
						<span>{{ tabcourseobj.StudyProgress ?? 0 }}%</span>
					</p>
					<div class="fontstimers flex" style="justify-content: space-between;">
						<p>
							创建时间：
							<span>{{ tabcourseobj.CO_CreationTime }}</span>
						</p>
						<p>
							<span class="fa fa-user" style="color: #1BB777;font-size: 16px;margin-right: 10px;"></span>
							<span style="color: red;">{{ tabcourseobj.CO_StudyCount?? 0 }}</span>
							人学习
						</p>
					</div>

					<!-- <div class="flex buttonscour">
						<p v-if="tabcourseobj.IsExistAdd == 1">已加入</p>
						<p v-if="tabcourseobj.IsExistAdd == 0">申请本课程</p>
						<p v-if="tabcourseobj.IsExistAdd == 2">审核中</p>
						<p v-if="tabcourseobj.IsExistAdd == 3">审核失败</p>
						<p v-if="tabcourseobj.IsExistCol == 1">已收藏</p>
						<p v-if="tabcourseobj.IsExistAdd == 0">收藏本课程</p>
						<el-popover placement="right-start" width="200" v-model="visible">
							<div style="height: 200px;border-radius: 10px;"><img style="width: 100%;height: 100%;"  :src="qrimg" alt="暂无二维码显示" /></div>
						</el-popover>
					</div> -->
				</div>
			</div>
		</div>
		<div class="contents">
			<div class="contentscours h-flex-x ">
				<p @click="cruuree = index" :class="{ scouractive: index == cruuree }" v-for="(item, index) in tabsles" :key="index">{{ item.name }}</p>
			</div>
			<div v-if="cruuree == 0" class="coursedesign">
				<div class="coursetitle">
					<p>课程背景</p>
					<div class="coursetcontent">{{ tabcourseobj.CO_Describe ?? '' }}</div>
				</div>
				<div class="coursetitle">
					<p>课程目标</p>
					<div class="coursetcontent">{{ tabcourseobj.CO_Objectives ?? '' }}</div>
				</div>
				<div class="coursetitle">
					<p>课程设计原则</p>
					<div class="coursetcontent">{{ tabcourseobj.CO_Desing ?? '' }}</div>
				</div>
			</div>

			<div class="trees" v-if="cruuree == 1">
				
				<div class="treestitleone" v-for="(heads, ie) in tabcourseobj.chiHeadings" :key="heads.HE_GUID">
					<p class="tresstiele">第{{ ie + 1 }}章 {{ heads.HE_HeadingsText }}</p>
					<div class="treestitletwo" v-if="heads.Sourcelist == 0" v-for="(headtwo, ietwo) in heads.chiHeadings" :key="headtwo.HE_GUID">
						<p class="treestitletwotitle">{{ headtwo.HE_HeadingsText }}</p>
						
						<div
							class="treestitletwotts flex"
							@click="opencourse(headthree)"
							style="align-items: center;"
							v-for="(headthree, iethree) in headtwo.Sourcelist"
							:key="headthree.cr_guid"
						>
							<span v-if="changecourse(headthree.cr_FileSuffix) == '文档'" class="el-icon-headset tressmp4icon"></span>

							<span v-if="changecourse(headthree.cr_FileSuffix) == '图片'" class="el-icon-picture tressmp4icon"></span>

							<span
								v-if="changecourse(headthree.cr_FileSuffix) == '视频' || changecourse(headthree.cr_FileSuffix) == '音频'"
								class="el-icon-video-camera-solid tressmp4icon"
							></span>
							<p>{{ headthree.cr_resourcetitle }}</p>
						</div>
					</div>

					<div class="treestitletwo" v-if="heads.Sourcelist > 0" v-for="(headfour, iefour) in heads.Sourcelist" :key="headfour.cr_guid">
						<div class="treestitletwotts flex" style="align-items: center;" @click="opencourse(headfour)">
							<span v-if="changecourse(headfour.cr_FileSuffix) == '文档'" class="el-icon-headset tressmp4icon"></span>

							<span v-if="changecourse(headfour.cr_FileSuffix) == '图片'" class="el-icon-picture tressmp4icon"></span>

							<span
								v-if="changecourse(headfour.cr_FileSuffix) == '视频' || changecourse(headfour.cr_FileSuffix) == '音频'"
								class="el-icon-video-camera-solid tressmp4icon"
							></span>
							<p>{{ headfour.cr_resourcetitle }}</p>
						</div>
					</div>
				</div>
			</div>

			<div v-if="cruuree == 2" class="coursedesign">
				<div v-if="tabcourseobj.CO_Standard">
					<div v-html="tabcourseobj.CO_Standard">
					
					</div>
				</div>
				<el-empty v-if="!tabcourseobj.CO_Standard" description="暂无标准,请联系老师添加课程标准"></el-empty>
			</div>

			<div v-if="cruuree == 3" class="coursedesign">
				<div class="textinput">
					<el-input v-on:keyup.13="send" type="textarea" placeholder="请输入内容" v-model="textarea" maxlength="500" :rows="6" show-word-limit></el-input>
				</div>
				<!-- @click="send()" -->
				<div class="h-flex-x h-flex-right coursebtn"><button>发送</button></div>
				<!-- Commentlist -->
				<div class="comment h-flex-y" v-for="(ite, idx) in Commentlist" :key="ite.CC_GUID">
					<div class="commenttop h-flex-x">
						<img :src="ite.ui_photoPath ?? defaultheader" alt="" srcset="" />
						<div>
							<p class="commentname">{{ ite.ui_userName }}</p>
							<p class="eltime">
								<span class="el-icon-time"></span>
								<span>{{ ite.CC_CommentTime }}</span>
							</p>
						</div>
					</div>
					<div class="content">{{ ite.CC_CommentContent }}</div>
					<div
						class="reply-btn"
						@click="
							ite.isShow = !ite.isShow;
							input = '';
						">
						回复
					</div>
					<div class="reply-input h-flex-x" v-if="ite.isShow">
						<el-input placeholder="请输入内容" v-model="input" clearable maxlength="200" show-word-limit></el-input>
						<el-button icon="el-icon-s-comment" @click="send(ite.CC_GUID, 1)" plain></el-button>
					</div>
					<div class="reply-getreply h-flex-y" v-for="(ites, ides) in ite.Chilist">
						<div class="reply-name h-flex-x">
							<span>{{ ites.ui_userName }}：</span>
							<span>{{ ite.ui_userName }}</span>
							<p>{{ ites.CC_CommentContent }}</p>
						</div>
						<div style="width: 100%;">
							<div class="h-flex-x">
								<p class="times">{{ ites.CC_CommentTime }}</p>
								<p class="reply-reply" style="margin-left: 10px;" @click="changerepy(idx, ides)">回复</p>
							</div>
							<div class="reply-input h-flex-x" v-if="ites.isShow">
								<el-input placeholder="请输入内容" v-model="chidinput" clearable maxlength="200" show-word-limit></el-input>
								<el-button icon="el-icon-s-comment" @click="send(ites.CC_GUID, 2)" plain></el-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<el-dialog :title="coursesobj.cr_resourcetitle" center :visible.sync="dialogTableVisible" @close="closedialog">
			<div class="contengtcourse">
				<div class="courseitem" v-if="changecourse(coursesobj.cr_FileSuffix) == '视频'">
					<video-player
						class="video-player vjs-custom-skin"
						ref="videoPlayer"
						:playsinline="true"
						:options="playerOptions"
						@play="onPlayerPlay($event)"
						@timeupdate="onPlayerTimeupdate($event)"
					></video-player>
				</div>
				
				<div class="courseitem" v-if="coursesobj.cr_FileSuffix == 'pdf' || coursesobj.cr_FileSuffix == 'PDF' || coursesobj.cr_FileSuffix == 'application/pdf' ||  coursesobj.cr_FileSuffix == 'text/html'">
					<iframe :src="coursesobj.cr_OriginalFileUrl" style="width:100%;height:600px" frameborder="0"></iframe>
				</div>
				<div class="courseitem" v-if="coursesobj.cr_FileSuffix == 'docx' || coursesobj.cr_FileSuffix == 'Docx'">
					<div style="width: 100%;height: 800px;border: 1px solid;">
						<vue-office-docx :src="coursesobj.cr_OriginalFileUrl" @rendered="rendered"/>
					</div>
				</div>
				<div class="courseitem" v-if="changecourse(coursesobj.cr_FileSuffix) == '图片'">
					<!-- <img :src="coursesobj.cr_OriginalFileUrl" style="width:100%;height:500px" frameborder="0"></img> -->
				
					<iframe :src="coursesobj.cr_OriginalFileUrl" style="width:100%;height:600px" frameborder="0"></iframe>
				</div>
				
				<div class="courseitem" v-if="coursesobj.cr_FileSuffix == 'html' || coursesobj.cr_FileSuffix == 'zip'">
					<web-view :src="coursesobj.cr_OriginalFileUrl"></web-view>
				</div>
			</div>
		</el-dialog>

		<Myfooters></Myfooters>
	</div>
</template>

<script>
import AppOptions from '../../config/AppOptions.vue';

import Myheaderesa from '@/components/layout/headeresa.vue';

import Myfooters from '@/components/layout/footers.vue';

import putaway from '@/components/putaway.vue';

import Viewer from '../../../node_modules/viewerjs/dist/viewer.min.js';

import '../../../node_modules/viewerjs/dist/viewer.min.css';

import { videoPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';

import { GetCourseCatalog, changeAddComment, getGetComment, getGetQRCode } from '@/request/api/homesview/yunhomes/yunhom.js';

//引入VueOfficeDocx组件
import VueOfficeDocx from '@vue-office/docx'


export default {
	components: {
		Myheaderesa,
		Myfooters,
		putaway,
		videoPlayer,
		VueOfficeDocx
	},
	data() {
		return {
			dialogTableVisible: false,
			chidinput: '',
			defaultheader: require('../../images/header.png'),
			// 评论
			input: '',
			textarea: '',
			coursecontent:
				'2022金砖国家技能发展与技术创新大赛由金砖国家工商理事会技能发展工作组（中方）提出并发起，一带一路暨金砖国家技能发展国际联盟为主要组织单位，其目标是为金砖国家建立人才选拔通道，提升人才培养能力，服务先进制造领域，促进金砖国家技能发展。本赛项围绕城市轨道交通站台门系统控制与调试需要掌握的知识点和技能进行设置。全面考察参赛选手对现场作业规程和制度的了解；对设备检查、维护维修及故障处理操作技能的掌握，以及应具备的安全生产意识和职业素养。',
			tabsles: [
				{
					name: '课程设计'
				},
				{
					name: '课程目录'
				},
				{
					name: '考核标准'
				},
				{
					name: '互动留言'
				}
			],
			tabcourseobj: {},
			visible: false,
			cruuree: 1,
			Commentlist: [],
			coursesobj: {},
			qrimg: '',
			// 视频组件
			playerOptions: {
				playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
				autoplay: false, // 如果为true,浏览器准备好时开始回放。
				muted: false, // 默认情况下将会消除任何音频。
				loop: false, // 是否视频一结束就重新开始。
				preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
				language: 'zh-CN',
				aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
				fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
				sources: [
					{
						type: 'video/mp4', // 类型
						src: '' // url地址
					}
				],
				poster: '', // 封面地址
				notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
				controlBar: {
					timeDivider: true, // 当前时间和持续时间的分隔符
					durationDisplay: true, // 显示持续时间
					remainingTimeDisplay: false, // 是否显示剩余时间功能
					fullscreenToggle: true // 是否显示全屏按钮
				}
			}
		};
	},
	computed: {},
	methods: {
		 rendered(){
		      console.log("渲染完成")
		    },
		// 打开课程
		opencourse(itm) {
			// console.log(itm);
			if (itm.cr_OriginalFileUrl) {
				this.coursesobj = itm;
				const fresh = new Date().getTime(); //时间戳
				if(itm.cr_FileSuffix== 'pdf' || itm.cr_FileSuffix == 'PDF'){
					setTimeout(()=>{
						this.coursesobj.cr_OriginalFileUrl = itm.cr_OriginalFileUrl + '?' + fresh;
						this.dialogTableVisible = true;
					},200)
				}else if(itm.cr_FileSuffix == 'docx' || itm.cr_FileSuffix == 'Docx'){
					
					this.dialogTableVisible = true;
				}else if(itm.cr_FileSuffix == 'html' ){
					// this.playerOptions.sources[0].src = itm.cr_OriginalFileUrl;
					this.dialogTableVisible = true;
				}else{
					this.$nextTick(()=>{
						this.playerOptions.sources[0].src = itm.cr_OriginalFileUrl;
						this.dialogTableVisible = true;
					})
					
				}
				
				
			} else {
				this.dialogTableVisible = false;
			}
		},
		closedialog() {
			this.$refs.videoPlayer.player.pause();
		},
		// 播放
		onPlayerPlay(e) {
			// console.log(e, '播放内容');
			let du = document.getElementById('vjs_video_3_html5_api');
			console.log(du)
		},
		onPlayerTimeupdate(e) {
			// console.log(e);
			let du = document.getElementById('vjs_video_3_html5_api');
			// console.log(du)
			var hour = parseInt(du.duration / 3600);
			var minute = parseInt((du.duration % 3600) / 60);
			var second = parseInt(du.duration % 60);
			let result = '';
			if (hour > 0) {
				result = this.formatTimeStr(hour) + ':' + this.formatTimeStr(minute) + ':' + this.formatTimeStr(second);
			} else {
				result = this.formatTimeStr(minute) + ':' + this.formatTimeStr(second);
			}
			// console.log(result, '播放内容');
		},
		formatTimeStr(val) {
			if (val > 9) {
				return val;
			} else {
				return '0' + val;
			}
		},
		// 回复
		changerepy(i, id) {
			let shows = this.Commentlist[i].Chilist[id].isShow;
			this.Commentlist[i].Chilist[id].isShow = !shows;

			this.chidinput = '';
		},
		changecourse(text) {
			let fixs = 'application/png|application/jpg|.jpg|.png|bmp|jpg|png|tif|gif|pcx|tga|exif|fpx|svg|psd|cdr|pcd|dxf|ufo|eps|ai|raw|WMF|webp|avif|apng';

			if (fixs.indexOf(text) >= 0) {
				return '图片';
			}

			fixs = 'ogg|mp4|flv|.mp4|.flv|application/mp4';
			if (fixs.indexOf(text) >= 0) {
				return '视频';
			}

			fixs = 'pdf|doc|docx|txt|application/pdf';
			if (fixs.indexOf(text) >= 0) {
				return '文档';
			}

			fixs = 'mp3|cd|wave|aiff|mpeg-4|midi|wma|ra|tm|tmx|vqf|amr|ape|flac|aac';
			if (fixs.indexOf(text) >= 0) {
				return '音频';
			}
		},
		prowimg() {
			// console.log('课程信息');
			var viewer = new Viewer(document.getElementById('imgsscour'), {
				url: require('@/images/wxewm.png') 
			});
			let erimg = {
				Id: this.$route.query.coguid,
				type: 1
			};
			getGetQRCode(erimg).then(res => {
				// console.log(res.data);
				this.qrimg =  'data:image/png;base64,'+ res.data;
			});
		},
		get() {
			let obj = {
				CO_GUID: this.$route.query.coguid
			};
			GetCourseCatalog(obj).then(res => {
				this.tabcourseobj = res.data.data;
			});
			this.getconmment();
		},
		getconmment() {
			let obj = {
				CO_GUID: this.$route.query.coguid
			};
			getGetComment(obj).then(res => {
				// console.log(res)
				if (res.data.data.length > 0) {
					this.Commentlist = res.data.data;
				} else {
					this.Commentlist = [];
				}
			});
		},
		send(paid = '', i) {
			// console.log(paid);
			let Comment = {
				CommentContent: paid == '' ? this.textarea : this.input,
				CO_GUID: this.tabcourseobj.CO_GUID,
				CC_GUID: paid
			};
			// console.log(paid, i);
			if (paid == '') {
				if (this.textarea == '') {
					this.$message('请输入留言');
					return;
				}
			} else {
				if (i == 1) {
					if (this.input == '') {
						this.$message('请输入回复留言');
						return;
					}
				} else {
					if (this.chidinput == '') {
						this.$message('请输入回复留言');
						return;
					}
				}
			}

			changeAddComment(Comment).then(res => {
				// console.log(res);
				if (res.data.code > 0) {
					this.textarea = '';
					this.input = '';
					this.chidinput = '';
					this.$message.success(res.data.msg);
					this.getconmment();
				}
			});
		}
	},
	mounted() {
		this.get();
	},
	created() {
		AppOptions.appEmpty = true;
	},
	beforeRouteLeave(to, from, next) {
		AppOptions.appEmpty = false;
		next();
	}
};
</script>

<style scoped lang="less">
.contengtcourse{
	overflow: scroll-y;
}
	

.contentscours {
	// display: flex;
	// margin: 10px 0;
	// width: 60%;
	border-bottom: 1px solid rgba(0, 0, 0, 0.3);
	p {
		text-align: center;
		width: 100px;
		font-size: 20px;
		font-weight: 500;
		padding: 10px 0;
		color: #000;
		cursor: pointer;
	}
	.scouractive {
		border-bottom: 4px solid #0054ff;
		color: #0054ff;
	}
}

.buttonscour {
	align-items: center;
	p {
		width: 100px;
		text-align: center;
		height: 30px;
		line-height: 30px;
		color: #fff !important;
		background-color: #1bb777;
		margin: 0 10px !important;
		border-radius: 20px;
		cursor: pointer;
	}
}

.detacontent {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box; //作为弹性伸缩盒子模型显示。
	-webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
	-webkit-line-clamp: 3; //显示的行
	font-size: 16px;
	margin: 20px 0;
}

.detailscontengt {
	width: 1200px;
	min-width: 1200px;
	margin: 40px auto 20px auto;
	.detailscontitle {
		font-size: 18px;
		color: #000;
	}
	img {
		width: 40px;
		height: 40px;
	}
	p {
		font-size: 16px;
		color: #b0b0b0;
		margin: 10px 0;
		span {
			color: #000;
		}
	}
	.fontstimers {
		font-size: 16px;
		color: #b0b0b0;
		margin: 10px 0;
		span {
			color: #000;
		}
	}
}

.contents {
	width: 1200px;
	min-width: 1200px;
	margin: 0 auto;
}

.headerscourdetail {
	position: relative;

	img {
		width: 100%;
	}
	.headerfonts {
		position: absolute;
		top: 40px;
		left: 50%;
		transform: translateX(-50%);
		text-align: center;

		p:first-child {
			font-size: 30px;
			color: #000;
			font-weight: 600;
		}
		p:last-child {
			font-size: 18px;
			margin-top: 10px;
			color: #fff;
		}
	}
}

.flex {
	display: flex;
}
.fley {
	display: flex;
	flex-direction: column;
}

.coursedesign {
	width: 100%;
	// height: 200px;
	// border: 1px solid;
	padding: 10px 30px;
	// background-color: #fff;
	border-radius: 5px;

	.comment {
		img {
			width: 60px;
			height: 60px;
			border-radius: 50%;
			margin-right: 20px;
		}
		p::before {
			display: none !important;
		}

		.reply-input {
			width: 60%;
			margin: 10px 0;

			button {
				background-color: #0054ff;
				color: #fff;
				margin-left: 20px;
			}

			/deep/ .el-input__inner {
				border-radius: 50px;
				height: 50px;
			}
		}

		.reply-getreply {
			margin: 10px 0;
			margin-left: 40px;
			border-left: 5px solid #cccccc;
			padding-left: 10px;
			width: 100%;

			.reply-name {
				font-size: 16px;
				p {
					font-size: 15px;
				}
			}
			.reply-reply {
				font-size: 14px;
				cursor: pointer;
			}

			.reply-reply:hover {
				color: #0054ff;
				cursor: pointer;
			}

			.times {
				color: #ccc;
				font-size: 14px;
			}
		}

		border-bottom: 1px solid #ccc;
		margin: 10px 0;
		padding: 20px 0;

		.content {
			margin-left: 30px;
			margin-top: 18px;
			font-size: 16px;
		}

		.reply-btn {
			width: 100%;
			text-align: right;
		}

		.reply-btn:hover {
			color: #0054ff;
			cursor: pointer;
		}

		.commenttop {
			div {
				font-size: 16px;
				.commentname {
					margin-bottom: 3px;
				}
				.eltime {
					font-size: 14px;
					padding-right: 2em;
					color: #aaa;
					vertical-align: middle;

					span {
						margin-left: 3px;
					}
				}
			}
		}
	}

	.coursebtn {
		button {
			width: 80px;
			text-align: center;
			height: 30px;
			line-height: 30px;
			background-color: #1bb777;
			color: #fff;
			border-radius: 5px;
		}
	}

	.textinput {
		// height: 200px;
		margin-bottom: 20px;

		/deep/ .el-input {
			height: 150px;
			input {
				height: 100%;
			}
		}
	}

	.coursetitle {
		margin: 10px 0;

		.coursetcontent {
			// margin: 0 20px;
			width: 100%;
			padding: 10px;
			box-sizing: border-box;
			margin-left: 10px;
		}
	}

	p {
		font-size: 20px;
		color: #000;
		padding-left: 5px;
		display: flex;
		align-items: center;
	}
	p::before {
		content: '';
		display: block;
		background-color: #0054ff;
		width: 5px;
		height: 20px;
		margin-right: 5px;
	}

	.scouractive {
		border-bottom: 4px solid #0054ff;
		color: #0054ff;
	}
}

.contents {
	margin-bottom: 60px;
	.treestitleone {
		margin-top: 20px;
		background-color: #fff;
		padding: 30px 20px;

		.tresstiele {
			font-size: 18px;
			color: #000;
			font-weight: 700;
		}
	}
	.treestitletwotitle {
		margin-left: 40px;
		margin-top: 20px;
		font-size: 16px;
		color: #000;
		cursor: pointer;
		
	}

	.treestitletwotts {
		margin-top: 10px;
		margin-left: 60px;
		cursor: pointer;

		.tressmp4icon {
			color: #efae43;
			margin-right: 10px;
			font-size: 18px;
		}
	}
}
</style>
